<template>
	<el-dialog v-dialogDrag :title="$t('friend.setTag')" :visible.sync="show" width="480px">
		<div class="friend-tag-editor">
			<div v-if="tags.length" class="tag-list">
				<div v-for="tag in tags" :key="tag.id" class="tag-item" @click="toggleTag(tag)">
					<el-checkbox :value="selectedIds.includes(tag.id)" @click.native.stop="toggleTag(tag)"></el-checkbox>
					<span class="tag-name">{{ tag.tagName }}</span>
					<span class="tag-count">{{ tag.count }}</span>
				</div>
			</div>
			<div v-else class="empty-tip">{{ $t('friend.noTagTip') }}</div>
			<div class="new-tag-row">
				<el-input v-model="newTagName" :placeholder="$t('friend.inputNewTag')" size="small"
					@keyup.enter.native="onCreateTag">
					<el-button slot="append" icon="el-icon-plus" @click="onCreateTag"></el-button>
				</el-input>
			</div>
		</div>
		<span slot="footer" class="dialog-footer">
			<el-button @click="close()">{{ $t('common.cancel') }}</el-button>
			<el-button type="primary" :loading="saving" @click="save()">{{ $t('common.confirm') }}</el-button>
		</span>
	</el-dialog>
</template>

<script>
export default {
	name: "friendTagEditor",
	data() {
		return {
			show: false,
			friendId: null,
			tags: [],
			selectedIds: [],
			newTagName: "",
			saving: false
		}
	},
	methods: {
		open(friend) {
			this.friendId = friend.id;
			this.newTagName = "";
			this.loadTags();
			this.show = true;
		},
		close() {
			this.show = false;
		},
		loadTags() {
			this.$http({
				url: '/friend/tag/list',
				method: 'GET'
			}).then((tags) => {
				this.tags = tags;
				this.selectedIds = this.friendStore.findFriendTagIds(this.friendId);
			})
		},
		toggleTag(tag) {
			let idx = this.selectedIds.indexOf(tag.id);
			if (idx >= 0) {
				this.selectedIds.splice(idx, 1);
			} else {
				this.selectedIds.push(tag.id);
			}
		},
		onCreateTag() {
			let name = this.newTagName.trim();
			if (!name) {
				return;
			}
			if (name.length > 32) {
				this.$message.warning(this.$t('friend.tagNameMax32'));
				return;
			}
			this.$http({
				url: '/friend/tag/create',
				method: 'POST',
				data: { tagName: name }
			}).then((tag) => {
				this.tags.push(tag);
				this.selectedIds.push(tag.id);
				this.newTagName = "";
			})
		},
		save() {
			this.saving = true;
			this.$http({
				url: '/friend/tag/set',
				method: 'PUT',
				data: { friendId: this.friendId, tagIds: this.selectedIds }
			}).then(() => {
				this.friendStore.loadTags();
				this.saving = false;
				this.close();
				this.$message.success(this.$t('friend.setTagSuccess'));
			}).catch(() => {
				this.saving = false;
			})
		}
	}
}
</script>

<style scoped lang="scss">
.friend-tag-editor {
	.tag-list {
		max-height: 300px;
		overflow-y: auto;
		margin-bottom: 10px;

		.tag-item {
			display: flex;
			align-items: center;
			padding: 8px 6px;
			cursor: pointer;
			border-radius: 8px;

			&:hover {
				background-color: var(--im-background-active);
			}

			.tag-name {
				flex: 1;
				margin-left: 8px;
				font-size: var(--im-font-size);
			}

			.tag-count {
				color: var(--im-text-color-light);
				font-size: var(--im-font-size-small);
			}
		}
	}

	.empty-tip {
		text-align: center;
		color: var(--im-text-color-light);
		padding: 20px 0;
		font-size: var(--im-font-size-small);
	}

	.new-tag-row {
		border-top: var(--im-border);
		padding-top: 10px;
	}
}
</style>
